export class AgentDefs {
    static agent_list = ['exten', 'visit', 'phone', 'minda', 'airbnb', 'real', 'other'];
}    
    
